import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AISharedState, AISharedStateFeatureKey } from './ai-shared.reducer';

export const selectAISharedFeature = createFeatureSelector<AISharedState>(
    AISharedStateFeatureKey,
);

export const selectAIIsSidePanelOpen = createSelector(
    selectAISharedFeature,
    (state) => state.isSidePanelOpen,
);
